if (window.location.href.indexOf('127.0.0.1') !== -1) {
  throw new Error('Use localhost instead of 127.0.0.1 for development!')
}

export const ExpressServerRoot =
  window.location.href.indexOf('localhost') !== -1 ? `http://localhost:5000` : ''

export const EduSectionTitle = 'Education'

export const ActionType = {
  Watched: 'watched',
  LaunchedApp: 'launched-app',
  PageView: 'page-view',
}
